function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { handleDeleteTable } from '@/libs/public';
import CreatPersonnel from './creatPersonnel.vue';
import { validatePhone } from '@/utils/toolsValidate';
import { personnelDeleteApi, personnelListApi } from '@/api/deliveryPersonnel';
import { defaultData } from '@/views/systemSetting/deliveryPersonnel/default';
export default {
  name: 'DeliveryPersonnel',
  components: {
    CreatPersonnel: CreatPersonnel
  },
  data: function data() {
    return {
      rules: {
        personnelPhone: [{
          validator: validatePhone,
          trigger: 'blur'
        }]
      },
      timeVal: [],
      tableFrom: {
        page: 1,
        dateLimit: '',
        personnelName: '',
        personnelPhone: '',
        limit: this.$constants.page.limit[0]
      },
      personnelName: '',
      tableData: {
        data: [],
        total: 0
      },
      loading: false,
      dialogVisible: false,
      editData: Object.assign({}, defaultData)
    };
  },
  created: function created() {
    if (checkPermi(['distribution:delivery:personnel:page'])) this.getList(1);
  },
  methods: {
    checkPermi: checkPermi,
    //重置
    handleReset: function handleReset() {
      this.tableFrom.dateLimit = '';
      this.tableFrom.personnelName = '';
      this.tableFrom.personnelPhone = '';
      this.timeVal = [];
      this.personnelName = '';
      this.getList();
    },
    handlerCloseFrom: function handlerCloseFrom() {
      this.dialogVisible = false;
    },
    handlerSuccessSubmit: function handlerSuccessSubmit() {
      this.getList(1);
      this.dialogVisible = false;
    },
    // 添加
    handleCreatPersonnel: function handleCreatPersonnel(row) {
      this.editData = row ? row : Object.assign({}, defaultData);
      this.dialogVisible = true;
    },
    // 分页
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.getList(1);
    },
    // 数据列表
    getList: function getList(num) {
      var _this = this;
      this.loading = true;
      var params = _objectSpread(_objectSpread({}, this.tableFrom), {}, {
        page: num ? num : this.tableFrom.page,
        personnelName: encodeURIComponent(this.personnelName)
      });
      personnelListApi(params).then(function (res) {
        _this.loading = false;
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this2 = this;
      this.$modalSure('确定要删除此配送人员吗？').then(function () {
        personnelDeleteApi(item.id).then(function (res) {
          _this2.$message.success('删除成功');
          handleDeleteTable(_this2.tableData.data.length, _this2.tableFrom);
          _this2.getList();
        });
      });
    }
  }
};